import errorMessages from "utils/validation/errorMessages";
import { emailSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';

const disciplineFormSchema = object().shape({
  name: string().required(errorMessages.required),
  assign_term: string().required(errorMessages.required),
  discipline_areas: array().of(
    object().shape({
      name: string().required(errorMessages.required)
    })
  )
});

export default disciplineFormSchema;